<template>
  <Provider>
    <Header />
  </Provider>
</template>

<script>
import Provider from './Provider'
import Header from './Header'

export default {
  components: {
    Provider,
    Header,
  },
}
</script>
